import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class H5EmptyBox extends Vue {
    @Prop() public desc!: string
}